import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AlertNotice } from 'shared/components';
import { TestCenterDTO } from 'shared/models';
import { INSTITUTION_STATUS as tcStatus } from 'shared/constants';

const TcStatus = (props) => {
  const { t } = useTranslation();
  const tc = new TestCenterDTO(props.tc);

  const renewCycle = tc.testCenterCycles.find(tcCycle =>
    tcCycle.status === tcStatus.renewalActive || tcCycle.status === tcStatus.renewalReview);
  const establishCycle = tc.testCenterCycles.find(tcCycle =>
    tcCycle.status === tcStatus.establish || tcCycle.status === tcStatus.establishReview);

  const renewButtons = () => (
    <div className="">
      <Link
        to={`/test-center-renewal/coordinator-agreement/${renewCycle.id}`}
        href={`/testing-center-renewal/coordinator-agreement/${renewCycle.id}`}
        className="ml-0 btn btn-action btn-renew"
      >
        {t('common.labels.renew')}
      </Link>
    </div>
  );

  const establishButton = () => (
    <div className="institution-action">
      <div className="pe-2 w-100 d-inline-block">
        <Link
          to={`/test-center-establishment/coordinator-agreement/${establishCycle.id}`}
          href={`/test-center-establishment/coordinator-agreement/${establishCycle.id}`}
          className="ml-0 btn btn-action btn-renew"
        >
          {t('testCenter.labelEstablish')}
        </Link>
      </div>
    </div>
  );

  return (
    <section className="tc-status-section">
      {tc.isRenewalActive &&
        <AlertNotice message={t('testCenter.renewalWarning')} type="warning" />
      }
      {tc.isEstablishActive &&
        <AlertNotice message={t('testCenter.establishWarning')} type="info" />
      }
      <div>
        {tc.isRenewalActive && renewButtons()}
        {tc.isEstablishActive && establishButton()}
      </div>
    </section>
  );
};

export default TcStatus;

TcStatus.propTypes = {
  tc: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    tcStatus: PropTypes.shape({}),
  }).isRequired,
};
